export enum searchStatus {
    isNotLoadedSearchId,
    isLoadedSearchId,
    isLoadedTickets,
    isErrorServer
}
